export default __webpack_public_path__ + "static/simple-area-191f28df116a782c75068bfc548f9077.png";